<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="老卡ICCID号：">
        <el-input
          v-model.trim="searchForm.oldSimIccid"
          @keyup.enter.native="getOldToNewListHandler"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="新卡ICCID号：">
        <el-input
          v-model.trim="searchForm.newSimIccid"
          @keyup.enter.native="getOldToNewListHandler"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="转卡时间：" class="dateRange">
        <el-date-picker
          v-model="searchForm.time"
          range-separator="至"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" @click="getOldToNewListHandler"
          >搜索查询</el-button
        >
        <el-button type="success" @click="exportOldToNewInfoHandle()"
          >导出Excel</el-button
        >
        <el-button type="primary" @click="showToNewCard">批量转卡</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tbpg.tableData" border>
      <el-table-column label="老卡卡号" width="160">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            @click="goToDetailPage(scope.row.oldSimIccid)"
            >{{ scope.row.oldSimIccid }}</a
          >
        </template>
      </el-table-column>

      <el-table-column label="新卡卡号" width="160">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            @click="goToDetailPage(scope.row.newSimIccid)"
            >{{ scope.row.newSimIccid }}</a
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="simPackageName"
        label="套餐名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="转卡已使用流量（G）">
        <template slot-scope="scope">
          <span>{{ fluxMtoG(scope.row.simPkgUsedRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="转卡时间"
        width="140"
      ></el-table-column>
      <!-- <el-table-column prop="createTime" label="状态"></el-table-column> -->
      <el-table-column
        prop="createOptName"
        label="操作人"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="failReason"
        label="失败原因"
        width="280"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]"
      :page-size="tbpg.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tbpg.total"
    >
    </el-pagination>
    <el-dialog
      :append-to-body="true"
      title="批量转新卡"
      :visible.sync="toNewCardVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="toNewCardForm" :model="toNewCardForm" label-width="120px">
        <el-form-item label="导入Excel：" prop="uploadExcel">
          <el-upload
            ref="upload"
            :action="uploadUrl('batch/change/import/sim/state')"
            :headers="setHeader()"
            :limit="1"
            :auto-upload="false"
            :data="toNewCardForm"
            :on-change="handleChange"
            :on-success="handleSuccess"
          >
            <el-button slot="trigger" plain>导入Excel</el-button>
            <el-button
              style="margin-left: 10px;"
              plain
              @click="exportExcel('/mould/to/new/sim')"
              >导出模板</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item label="类型：" prop="moveType">
          <el-radio-group v-model="toNewCardForm.moveType">
            <el-radio label="1">全部</el-radio>
            <el-radio label="2">仅转流量</el-radio>
            <el-radio label="3">仅转层级</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureToNewCardHandler"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getOldToNewList, exportChangeSimRecord} from "@/api/sim.js";
import common from "@/utils/common.js";
export default {
  data() {
    return {
      searchForm: {
        oldSimIccid: "",
        newSimIccid: "",
        time: null,
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      toNewCardVisible: false, //转新卡
      toNewCardForm: {
        moveType: "1",
      },
    };
  },
  methods: {
    cancel() {
      this.toNewCardVisible = false;
      this.$refs.toNewCardForm.resetFields();
    },
    getOldToNewListHandler($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      getOldToNewList(data).then((res) => {
        common.listCallback(this, res, "tbpg");
      });
    },
    showToNewCard() {
      this.toNewCardVisible = true;
    },
    sureToNewCardHandler() {
      this.$refs.upload.submit();
      this.toNewCardVisible = false;
    },
    goToDetailPage(iccid) {
      this.$store.commit("menu/setFromPage", "orderMgt");
      this.$store.commit("menu/setFromPageIccid", iccid);
      document.getElementById("cardDetailsMenu").click();
    },

    exportOldToNewInfoHandle() {
      common.deleteSpaceKey(this.searchForm); 
      //导出excel文件
      this.$confirm("您确定要导出数据吗？", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
      })
        .then(() => {
          exportChangeSimRecord(this.searchForm)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success("数据导出中,请稍候去下载专区下载");
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => console.error(err));
        })
        .catch(() => {});
    },

    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.$refs.toNewCardForm.fields[0].clearValidate();
      }
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.importCardVisible = false;
        this.getOldToNewListHandler();
        this.$refs.upload.clearFiles();
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getOldToNewListHandler();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getOldToNewListHandler();
    },
  },
  created() {
    this.getOldToNewListHandler();
  },
};
</script>

<style lang="less" scoped></style>
